import apiFetch from '../../../utils/apiFetch';

const post = async (url, body, fallback) => {
  const response = await apiFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.message || fallback);
  return result;
};
const base = campaignId => `/campaigns/${encodeURIComponent(campaignId)}/fate-windows`;

/** The DM's attack hit: open an Improve Fate window (or learn nobody can use one). */
export const openFateWindow = (campaignId, attack) => post(base(campaignId), attack, 'The Improve Fate window could not be opened.');
/** A holder uses or declines it (`helperId`); the DM skips it (no `helperId`). */
export const decideFateWindow = (campaignId, windowId, body) =>
  post(`${base(campaignId)}/${encodeURIComponent(windowId)}/decide`, body, 'Improve Fate could not be saved.');
/** The DM follows one window (`windowId`); a player lists the windows their character may answer (`characterId`). */
export const syncFateWindows = (campaignId, body) => post(`${base(campaignId)}/sync`, body, 'Improve Fate windows could not be loaded.');
